import { render, staticRenderFns } from "./purchase-comment-edit-block.vue?vue&type=template&id=c0a6e120&"
import script from "./purchase-comment-edit-block.vue?vue&type=script&lang=js&"
export * from "./purchase-comment-edit-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0a6e120')) {
      api.createRecord('c0a6e120', component.options)
    } else {
      api.reload('c0a6e120', component.options)
    }
    module.hot.accept("./purchase-comment-edit-block.vue?vue&type=template&id=c0a6e120&", function () {
      api.rerender('c0a6e120', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/purchase-comment-edit-block.vue"
export default component.exports